export default "__VITE_ASSET__BG149d5K__"